import { useMantineTheme } from '@mantine/core';
import { BaseEdge, Position, type EdgeProps } from '@xyflow/react';
import { getERDFlowSmoothStepPath } from '../../utils/getERDFlowSmoothStepPath';

export function TableEdge({
	id,
	sourceX,
	sourceY,
	targetX,
	targetY,
	sourcePosition,
	targetPosition,
	markerEnd,
}: EdgeProps) {
	const theme = useMantineTheme();

	const [edgePath] = getERDFlowSmoothStepPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
		position: Position.Left,
	});

	const style = {
		stroke: theme.other.getColor('border/primary/default'),
		strokeWidth: 1,
	};

	return (
		<BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
	);
}
